export default __webpack_public_path__ + "static/CRUCES_PRINCIPAL-d19734d0da3f8a72ea2f3f4cf7c7b603.jpg";